<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style1', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <MainNavbarPages />
    </div>

    <div class="content-wrapper">
      <div id="contact" class="contact-wrap ptb-100">
        <div class="container">
          <!-- Secțiune Titlu -->
          <div class="section-title text-center mb-50">
            <span>Informații de Contact</span>
            <h2>Suntem Aici Pentru Dumneavoastră</h2>
            <p class="subtitle">Ne puteți găsi la sediu, ne puteți apela sau ne puteți scrie direct pe WhatsApp.</p>
          </div>

          <!-- Grid principal: Carduri + Hartă -->
          <div class="row g-4 align-items-stretch">
            
            <!-- Coloana Stânga: Carduri de Informații -->
            <div class="col-lg-5 col-md-12">
              <div class="info-cards-wrapper d-flex flex-column gap-4 h-100 justify-content-between">
                
                <!-- Card 1: Telefon & WhatsApp -->
                <div class="contact-info-card">
                  <div class="icon-box">
                    <i class="ri-phone-line"></i>
                  </div>
                  <div class="card-details">
                    <h3>Telefon & WhatsApp</h3>
                    <p class="phone-number">+40 753 704 812</p>
                    <a 
                      href="https://wa.me/40753704812" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      class="btn-whatsapp"
                    >
                      <i class="ri-whatsapp-line"></i> Scrie-ne pe WhatsApp
                    </a>
                  </div>
                </div>

                <!-- Card 2: Program de Lucru -->
                <div class="contact-info-card">
                  <div class="icon-box">
                    <i class="ri-time-line"></i>
                  </div>
                  <div class="card-details">
                    <h3>Program de Lucru</h3>
                    <div class="schedule-item">
                      <span class="days">Luni - Vineri:</span>
                      <span class="hours">08:00 - 18:30</span>
                    </div>
                    <div class="schedule-item muted">
                      <span class="days">Sâmbătă - Duminică:</span>
                      <span class="hours">Închis</span>
                    </div>
                  </div>
                </div>

                <!-- Card 3: Adresă -->
                <div class="contact-info-card">
                  <div class="icon-box">
                    <i class="ri-map-pin-line"></i>
                  </div>
                  <div class="card-details">
                    <h3>Adresa Noastră</h3>
                    <p class="location-tag">Localizată în: <strong>Negrești</strong></p>
                    <p class="address-text">Strada Decebal 5, CP 735200, Negrești, Vaslui</p>
                  </div>
                </div>

              </div>
            </div>

            <!-- Coloana Dreapta: Hartă Google Maps -->
            <div class="col-lg-7 col-md-12">
              <div class="map-container-wrapper h-100">
                <iframe
                  title="Google Map Location"
                  src="https://maps.google.com/maps?q=Pozitiv%20Medical%20Strada%20Decebal%205%20Negresti&t=&z=16&ie=UTF8&iwloc=&output=embed"
                  loading="lazy"
                  class="google-map-iframe"
                ></iframe>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../Layouts/TopHeader.vue";
import MainNavbarPages from "../Layouts/MainNavbarPages.vue";
import MainFooter from "../Layouts/MainFooter.vue";

export default {
  name: "ContactPage",
  components: {
    TopHeader,
    MainNavbarPages,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
};
</script>

<style scoped>
.ptb-100 {
  padding-top: 80px;
  padding-bottom: 80px;
}

.section-title {
  margin-bottom: 40px;
}

.section-title span {
  color: #ff375f;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 14px;
}

.section-title h2 {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin-top: 8px;
}

.section-title .subtitle {
  color: #64748b;
  font-size: 16px;
  max-width: 600px;
  margin: 10px auto 0;
}

/* Stiluri Carduri Contact */
.contact-info-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  border: 1px solid #f1f5f9;
  transition: all 0.3s ease;
}

.contact-info-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08);
}

.icon-box {
  width: 52px;
  height: 52px;
  background-color: #eff6ff;
  color: #ff375f;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex-shrink: 0;
}

.card-details h3 {
  font-size: 18px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 8px;
}

.phone-number {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 12px;
}

/* Buton WhatsApp */
.btn-whatsapp {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #25d366;
  color: #ffffff;
  padding: 10px 18px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.btn-whatsapp:hover {
  background-color: #1ebc57;
  color: #ffffff;
  transform: scale(1.02);
}

/* Program de lucru */
.schedule-item {
  display: flex;
  gap: 12px;
  font-size: 15px;
  font-weight: 500;
  color: #334155;
  margin-bottom: 4px;
}

.schedule-item.muted {
  color: #94a3b8;
}

/* Adresă */
.location-tag {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 4px;
}

.address-text {
  font-size: 15px;
  color: #334155;
  font-weight: 500;
  margin: 0;
}

/* Container Harta Google */
.map-container-wrapper {
  min-height: 400px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  border: 1px solid #f1f5f9;
}

.google-map-iframe {
  width: 100%;
  height: 100%;
  min-height: 420px;
  border: 0;
}

/* Ajustări Responsivitati */
@media (max-width: 991px) {
  .map-container-wrapper {
    height: 380px;
  }
}
</style>